import { Component } from 'react'

import { PageLimitLabelStyled } from './styles/PageLimitLabelStyled'
import { PageLimitSelectStyled } from './styles/PageLimitSelectStyled'
import { PageLimitStyled } from './styles/PageLimitStyled'
import { type ISelectProps, Select } from '../../elements/Select'

export interface IPageLimitProps {
  value?: PageLimitValue
  options?: PageLimitValue[]
  onChange?: ISelectProps['onChange']
  /**
   * Id of the page size select's input, which the "Results Per Page" label
   * points at. Give each page limit on a screen its own id. Defaults to
   * `results-per-page-select`.
   */
  inputId?: string
}

export interface PageLimitValue {
  value: string
  label: string
}

export class PageLimit extends Component<IPageLimitProps> {
  static defaultProps = {
    value: { value: '10', label: '10' },
    options: [
      { value: '10', label: '10' },
      { value: '25', label: '25' },
      { value: '50', label: '50' },
      { value: '100', label: '100' },
    ],
    inputId: 'results-per-page-select',
  }

  render() {
    const { value, options, onChange, inputId } = this.props

    return (
      <PageLimitStyled>
        <PageLimitLabelStyled htmlFor={inputId}>
          Results Per Page:{' '}
        </PageLimitLabelStyled>
        <PageLimitSelectStyled>
          <Select
            inputId={inputId}
            className='select'
            value={value}
            onChange={onChange}
            options={options}
          />
        </PageLimitSelectStyled>
      </PageLimitStyled>
    )
  }
}
